<template>
  <generic-modal :title="$t('product purchasing')" ref="generic_modal">
    <form>
      <div class="field" v-if="meta.product && meta.product.product_id">
        <label class="label">{{ $t("product") }}</label>
        <input type="text" class="input" disabled :value="meta.product.name" />
      </div>
      <div class="field">
        <label class="label">{{ $t("quantity") }}</label>
        <input
          class="input"
          type="number"
          v-model="meta.quantity"
          min="1"
          required
        />
      </div>
      <div class="field">
        <label class="label">{{ $t("purchase price") }}</label>
        <input
          class="input"
          type="number"
          v-model="meta.purchase_price"
          min="0"
          required
        />
      </div>
    </form>
    <p class="buttons is-pulled-right mt-2">
      <a class="button is-static is-size-5 has-text-warning">
        {{ format_currency(total_payment) }} <br />
        {{ $t("total to pay") }}
      </a>
    </p>
    <!-- <pre>{{ meta }}</pre> -->
    <!-- <pre>{{ $props.module_settings }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ProductPurchasingModal",
  components: { GenericModal },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      meta: {},
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      // return v.pending > 0 /* || !v.meta.sale_price */;
    },
    total_payment() {
      let v = this;
      return Number(v.meta.quantity) * Number(v.meta.purchase_price);
    },
  },
  methods: {
    get_currency_settings,
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(product) {
      // console.log("product", product);
      let v = this;
      v.set_initial_state();
      v.meta.product = product;
      v.meta.quantity = Math.floor(Math.random() * 10) + 1;
      v.meta.purchase_price = (Math.random() * 100).toFixed(2);
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      v.$emit("success", { ...v.meta });
      v.$refs.generic_modal.close_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        product: {},
        quantity: 1,
        purchase_price: 0,
        settings: {},
      };
      v.payment_methods = [];
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
